var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-drop-down"},[(_vm.disabled)?_c('drop-down',{staticClass:"dropdown dropdown-disable",attrs:{"title":"批量操作"},on:{"select":_vm.handle}}):_c('drop-down',{staticClass:"dropdown",attrs:{"title":"批量操作","data":_vm.batchData},on:{"select":_vm.handle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }